import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisPlatformAnalysisQuery = (
  campaignId: string,
  platformId: string,
  facilityId?: string | string[],
  range?: ReviewAnalysisDateRange,
  venueName?: string
) =>
  useQuery({
    enabled: !!campaignId && !!platformId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      ReviewAnalysisApiService.getPlatformAnalysis(
        campaignId,
        platformId,
        facilityId,
        range,
        venueName
      ),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_PLATFORM_ANALYSIS,
      campaignId,
      platformId,
      facilityId,
      range?.from ?? '',
      range?.to ?? '',
      venueName ?? '',
    ],
  })
